import { render, staticRenderFns } from "./selection-recommended.vue?vue&type=template&id=baa8fcd2&scoped=true&"
import script from "./selection-recommended.vue?vue&type=script&lang=js&"
export * from "./selection-recommended.vue?vue&type=script&lang=js&"
import style0 from "./selection-recommended.vue?vue&type=style&index=0&id=baa8fcd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa8fcd2",
  null
  
)

export default component.exports